import {SideMenuView} from '../view/side_menu_view';
import {connect} from "react-redux";
import { setSideMenuDropdownIsOpen, setSideMenuEntry, setSideMenuCollapse } from "../actions/side_menu_actions";
import { RootState } from "../../../app/store"
import { Dispatch } from '@reduxjs/toolkit';
import { library } from '@fortawesome/fontawesome-svg-core';
import {fas} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(fas);

function mapStateToProps(state:RootState){
    return {
        // Structure: Link, Text, Symbol
        menuItems:[
            ["/login", "Login", <FontAwesomeIcon icon={["fas", "power-off"]}/>, [0]],
            ["/dashboard", "Dashboard", <FontAwesomeIcon icon={["fas", "tachometer-alt"]}/>, [1,2]],
            ["/newsmanager", "NewsManager", <FontAwesomeIcon icon={["fas", "newspaper"]}/>, [1,2]],
            //["/networkgraph", "Netzwerkuebersicht ", <FontAwesomeIcon icon={["fas", "sitemap"]}/>,[1,2]],
            ["","Verwaltung", " ",[2]],
            ["/Benutzer", "User ", <FontAwesomeIcon icon={["fas", "users"]}/>,[2]],
            ["/license", "License ", <FontAwesomeIcon icon={["fas", "scroll"]}/>,[2]],
            ["/Updates", "Updates ", <FontAwesomeIcon icon={["fas", "cubes"]}/>,[2]],
            // Emergency upload of a release; the normal route is the release pipeline.
            ["/UpdateManager", "SideMenu:EmergencyUpload", <FontAwesomeIcon icon={["fas", "triangle-exclamation"]}/>,[2]],
            ["/Script", "Scripts ", <FontAwesomeIcon icon={["fas", "box"]}/>,[2]],    
            ["/ScriptUploader", "Script Manager ", <FontAwesomeIcon icon={["fas", "box"]}/>,[2]],    
            // "Benchmark" retired 08.10.2026 (empty tables, CIS lives in cisdb).
            ["/Mandanten", "Mandanten ", <FontAwesomeIcon icon={["fas", "building"]}/>,[2]],
            ["/Statistic", "Statistik ", <FontAwesomeIcon icon={["fas", "horse"]}/>,[2]],
            // The label is a message id; the view translates it (de.js/en.js).
            ["/AuthSettings", "SideMenu:AuthSettings", <FontAwesomeIcon icon={["fas", "right-to-bracket"]}/>,[2]],
            // Section "Hilfe" removed 08.10.2026 (user decision): its entry
            // "User" (/HelpUser) was a placeholder card ("Here could be a
            // helpfile for the user"). Its other entry "Administratoren"
            // (/HelpAdmin, the "Support Shell Interactive" that put a
            // WireGuard peer into the customer network) was retired on
            // 21.09.2026 - SupportController carries [NonController]; the
            // HelpAdmin feature folder went with the section.
        ],
        isDropdownOpen:state.topMenu.isDropdownOpen,
        collapsed: state.sideMenu.collapsed,
        role:state.LoginManager.model.role,
    }
}

function bindDispatchToActions(dispatch:Dispatch<any>){
    return {
        onMenuItemClickedCb:(item:string) => {
            dispatch(setSideMenuDropdownIsOpen({isopen:true}));
            dispatch(setSideMenuEntry({nextentry:item}));
        },
        onMenuCollapseCb:() => {
            dispatch(setSideMenuCollapse({collapsed:true}));
            // FIXME toogle variable
            console.log("Fold / unfold");
        },
    }
}

const SideMenuViewContainer=connect(mapStateToProps, bindDispatchToActions)(SideMenuView);
export default SideMenuViewContainer;